var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'app-shell': _vm.showRecordFooter },attrs:{"id":"app"}},[_c('main',{class:{ 'app-main': _vm.showRecordFooter }},[_c('router-view')],1),(_vm.showRecordFooter)?_c('CashierRecordFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }